document.addEventListener('DOMContentLoaded', function () {
  const sandwichEl = document.querySelector('.sandwich-max-quantity');
  let MAX_TOTAL = parseInt(sandwichEl.dataset.quantity, 10); // initial value
  const addToCartBtn = document.querySelector('.add-to-cart');
  const mainSelectionBox = document.querySelector('#main-selection');
  const totalYour = document.querySelector('.total-your');
  const priceBox = document.querySelector('.price-per-box');

  let sandwichGroup = null;
  let muffinGroup = null;

  // ✅ helper to refresh MAX_TOTAL whenever needed
  function updateMaxTotal() {
    MAX_TOTAL = parseInt(sandwichEl.dataset.quantity, 10);
  }

  function updateTotalText() {
    const totalSandwich = sandwichGroup ? sandwichGroup.getTotal() : 0;
    const totalMuffin = muffinGroup ? muffinGroup.getTotal() : 0;
    const totalQty = totalSandwich + totalMuffin;

    if (addToCartBtn.disabled) {
      if (totalQty === 0) {
        totalYour.innerText = "Select your package size";
        priceBox.style.display = "none";
      } else {
        totalYour.innerText = `Select ${MAX_TOTAL} items`;
         priceBox.style.display = "flex";
      }
    } else {
      totalYour.innerText = "Your total";
       priceBox.style.display = "flex";
    }
  }

  function checkGlobalState() {
    updateMaxTotal();
    if (!sandwichGroup || !muffinGroup) {
      addToCartBtn.disabled = true;
      updateTotalText();
      return;
    }
    addToCartBtn.disabled = !(
      sandwichGroup.getTotal() >= MAX_TOTAL &&
      muffinGroup.getTotal() >= MAX_TOTAL
    );
     updateTotalText();
  }

  // Reset all quantities to 0 when max changes
  function resetQuantities() {
    document.querySelectorAll('.cat-qty-input').forEach(input => {
      input.value = 0;
    });
    if (sandwichGroup) sandwichGroup.updateStates();
    if (muffinGroup) muffinGroup.updateStates();
    checkGlobalState();
  }

  // Watch for changes on sandwich-max-quantity
  const observer = new MutationObserver(() => {
    resetQuantities();
  });
  if (sandwichEl) {
    observer.observe(sandwichEl, { attributes: true, attributeFilter: ['data-quantity'] });
  }

   function getSelectedItemsHTML(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return '';
    let html = '';
    container.querySelectorAll('.sandwich-data-info-quantity').forEach(item => {
      const qty = parseInt(item.querySelector('.cat-qty-input').value) || 0;
      if (qty > 0) {
        const name = item.querySelector('.sandwich_items_info h2').textContent.trim();
        html += `<div class="selected-item">
                  <span>${name}</span> (${qty})
                 </div>`;
      }
    });
    return html;
  }

  // Quantity group logic
  function initQuantityGroup(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return null;

    const qtyInputs = container.querySelectorAll('.cat-qty-input');
    const plusButtons = container.querySelectorAll('.cat_quantity__button[name="plus"]');
    const minusButtons = container.querySelectorAll('.cat_quantity__button[name="minus"]');

    function getTotal() {
      return Array.from(qtyInputs).reduce((total, input) => total + (parseInt(input.value) || 0), 0);
    }

    function updateStates() {
      updateMaxTotal();
      const totalQty = getTotal();
      plusButtons.forEach(btn => (btn.disabled = totalQty >= MAX_TOTAL));
      minusButtons.forEach(btn => {
        const input = btn.closest('.quantity').querySelector('.cat-qty-input');
        btn.disabled = parseInt(input.value) <= 0;
      });
      checkGlobalState();
    }

    container.querySelectorAll('.cat_quantity__button').forEach(button => {
      button.addEventListener('click', function () {
        updateMaxTotal();
        const input = this.closest('.quantity').querySelector('.cat-qty-input');
        let value = parseInt(input.value) || 0;
        const totalQty = getTotal();

        if (this.name === 'plus' && totalQty < MAX_TOTAL) value++;
        else if (this.name === 'minus' && value > 0) value--;

        input.value = value;
        updateStates();
      });
    });

    qtyInputs.forEach(input => {
      input.addEventListener('input', function () {
        updateMaxTotal();
        let value = parseInt(this.value) || 0;
        if (value < 0) value = 0;
        const otherTotal = getTotal() - (parseInt(this.value) || 0);
        if (otherTotal + value > MAX_TOTAL) value = MAX_TOTAL - otherTotal;
        this.value = value;
        updateStates();
      });
    });

    updateStates();
    return { getTotal, updateStates };
  }

  sandwichGroup = initQuantityGroup('.sandwich-data-info-main');
  muffinGroup = initQuantityGroup('.muffin-data-info-main');

  checkGlobalState();

});